
import { serializable, alias, object, list, primitive } from 'serializr';

export class ProcessingFacilityEmissionData {

	@serializable(alias('co2e', primitive()))
	co2e?: number;

	@serializable(alias('normalised_co2e', primitive()))
	normalised_co2e?: number;  // not changing to camelCase because fo regression impact

	@serializable(alias('normalised_co2e_stage', primitive()))
	normalisedCo2eStage?: number;

	@serializable(alias('processingFacilityName', primitive()))
	processingFacilityName?: string;

	@serializable(alias('productId', primitive()))
	productId?: number;

}